import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Registration } from '../Models/registration';
import { environment } from '../../environments/environment';

const httpPostOptions =
{
  headers:
    new HttpHeaders(
      {
        "Content-Type": "application/x-www-form-urlencoded"
      }),
  withCredentials: true,
};

const httpGetOptions =
{
  withCredentials: true,
};

//const httpOptions = {
//  headers: new HttpHeaders({
//    'Content-Type': 'application/json'
//  })
//};

@Injectable({
  providedIn: 'root'
})

export class RegistrationserviceService {

  APIURL = environment.apiUrl;

  constructor(private http: HttpClient) { }

  // Login And Register Investor Account
  LoginAndRegisterInvestorAccount(registration: Registration): Observable<Registration> {
    debugger;

    var Telephone = registration.Telephone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");

    return this.http.post<Registration>(this.APIURL + 'LoginAndRegisterInvestorAccount?emailAddress=' + registration.EmailId + '&firstName=' + registration.FirstName + '&lastName=' + registration.LastName + '&phoneNumber=' + Telephone + '&phoneNumberExt=' + registration.Extension + '&userAcceptedLegalAgreement=' + true, httpPostOptions);
  }

  // Get Investor Account
  getRegisterUserByEmailID(emailId: string): Observable<Registration> {
    debugger;
    return this.http.get<Registration>(this.APIURL + 'QueryInvestorAccount?emailAddress=' + emailId, httpGetOptions);
  }

  // Logout Investor Account  
  LogoutInvestorAccount(): Observable<Registration> {
    debugger;
    return this.http.post<Registration>(this.APIURL + 'LogoutInvestorAccount', httpPostOptions);
  }
}
